import { useState, useEffect, memo } from "react";
import AnimacionCarga from "./animacion_de_carga";
import BarraSuperior from "./barra_superior";
import { useAuth } from "../../functions/AuthContext";

const API_URL = "https://coordiph.herokuapp.com/api/legal";

const estilos = {
  contenedor: {
    maxWidth: "860px",
    margin: "0 auto",
    padding: "24px 16px",
    fontFamily: "inherit",
  },
  tabs: {
    display: "flex",
    borderBottom: "2px solid #e0e0e0",
    marginBottom: "24px",
    gap: "4px",
  },
  tab: (activo) => ({
    padding: "10px 28px",
    border: "none",
    borderBottom: activo ? "3px solid #d32f2f" : "3px solid transparent",
    background: "none",
    color: activo ? "#d32f2f" : "#555",
    fontWeight: activo ? "700" : "400",
    fontSize: "15px",
    cursor: "pointer",
    transition: "color 0.2s, border-color 0.2s",
    outline: "none",
    marginBottom: "-2px",
  }),
  texto: {
    fontSize: "15px",
    lineHeight: "1.75",
    color: "#333",
    textAlign: "justify",
    whiteSpace: "pre-wrap",
    padding: "8px 4px",
  },
};

const Legal = memo(() => {
  const [tabActiva,       setTabActiva]       = useState(0);
  const [textoTerminos,   setTextoTerminos]   = useState("");
  const [textoPrivacidad, setTextoPrivacidad] = useState("");
  const [cargando,        setCargando]        = useState(true);
  const { usuario } = useAuth();

  useEffect(() => {
    const obtenerDatos = async () => {
      try {
        const res  = await fetch(API_URL);
        const data = await res.json();
        setTextoTerminos(  data.terminosycondiciones || "No disponible.");
        setTextoPrivacidad(data.politicadeprivacidad  || "No disponible.");
      } catch (error) {
        console.error("Error al obtener datos legales:", error.message);
        setTextoTerminos("No se pudo cargar el contenido.");
        setTextoPrivacidad("No se pudo cargar el contenido.");
      } finally {
        setCargando(false);
      }
    };

    obtenerDatos();
  }, []);

  if (cargando) return <AnimacionCarga />;

  const tabs = [
    { label: "Términos y condiciones", contenido: textoTerminos },
    { label: "Privacidad",             contenido: textoPrivacidad },
  ];

  return (
    <>
      {usuario && <BarraSuperior />}
      <div style={estilos.contenedor}>
        <div style={estilos.tabs}>
          {tabs.map((tab, i) => (
            <button
              key={i}
              style={estilos.tab(tabActiva === i)}
              onClick={() => setTabActiva(i)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <p style={estilos.texto}>{tabs[tabActiva].contenido}</p>
      </div>
    </>
  );
});

export default Legal;